import { ComponentType, Suspense } from 'react';

const withSuspense = <P extends object>(
  LazyComponent: ComponentType<P>,
  Fallback?: ComponentType<P>
): ComponentType<P> => {
  const DeferredComponent = (props: P) => (
    <Suspense fallback={Fallback ? <Fallback {...props} /> : null}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return DeferredComponent;
};

export default withSuspense;
